import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import {TopButtonPointAction, TopButtonPointRemove} from "../../../../../componentsTopsa/buttons/TopButtons";
import tabgrid from "../../../../../utilities/TabGrid";
import acc from 'accounting'
import ReactTooltip from 'react-tooltip'
import {Checkbox, Col, ControlLabel, Row} from "react-bootstrap";
import initialData from "../../../../../utilities/initialData/initialData";
import InfoTooltip from "../../../../../componentsTopsa/infoTooptip/InfoTooltip";
import {Link} from "react-router-dom";
import MiesieczneTableStatus from "./MiesieczneTableStatus";
import LSService from "../../../../../utilities/localStorageService/LSService";
import KonfiguracjaService from "../../../../administracja/konfiguracja/KonfiguracjaService";
import WystawFaktureZaBiletMiesieczny from "../../fakturyBilety/externalComponents/WystawFaktureZaBiletMiesieczny";
import WyslijMailDoKlientaPopup from "../../../../komunikaty/powiadomienia/external_component/WyslijMailDoKlientaPopup";
import BiletyService from "../../biletyApi/BiletyService";
import download from "downloadjs";

export default class MiesieczneTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            miesiace: [],
            statusy: [
                {value: -1, label: 'do opłaty', ikona: 'fa fa-times-circle-o', kolor: '#333'},
                {value: 1, label: 'opłacony', ikona: 'fa fa-check-circle-o', kolor: '#333'},
                {value: -2, label: 'anulowany', ikona: 'fa fa-times', kolor: '#333'},
            ],
            kolumny: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            pokazModal: false,
            bilet: null,

            pokazPopupWyslijEmail: false,
            adresatEmail: ""
        };
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
        this.renderMiesiacRok = this.renderMiesiacRok.bind(this)
        this.renderStatusy = this.renderStatusy.bind(this)
        this.onClickChangeColumnVisible = this.onClickChangeColumnVisible.bind(this)
    }

    componentDidMount() {
        this.initMiesiace()
        this.pobierzKoloryStatusowBiletow()
        if (Boolean(LSService.pobierzZestawKolumnWBiletachMiesiecznych())) {
            this.setState({kolumny: LSService.pobierzZestawKolumnWBiletachMiesiecznych()})
        }
        else {
            LSService.ustawZestawKolumnWBiletachMiesiecznych([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])
        }
    }

    initMiesiace() {
        let arr = initialData.returnArrayMiesiace()
        this.setState({miesiace: arr})
    }

    pobierzKoloryStatusowBiletow() {
        KonfiguracjaService.pobierzObiektySekcji('Status-kolor').then(function (response) {
            if (Boolean(response.data)) {

                let arr = response.data.filter(p => p.sekcja === 'Status-kolor')

                let statusyarr = this.state.statusy
                for (let i = 0; i < statusyarr.length; i++) {
                    let statuskolor = arr.find(p => p.pozycja == statusyarr[i].label)
                    if (Boolean(statuskolor)) {
                        statusyarr[i].kolor = statuskolor.wartosc
                    }
                }

                this.setState({statusy: statusyarr})

            }

        }.bind(this))
    }

    renderButtonyAkcji(cell, row) {
        if (!Boolean(row.idBmGl)) {
            return (
                <div>
                    <TopButtonPointRemove onClick={() => {
                        this.props.handleUsun(row)
                    }} titleContent={'Usuń bilet'}/>
                </div>
            )
        } else return ''
    }

    onClickChangeColumnVisible(id) {
        let div = document.getElementById('visibilitycolumncheckboxes')
        let checks = div.getElementsByTagName('input')

        let arr = []

        for (let i = 0; i < checks.length; i++) {
            if (checks[i].checked) {
                arr.push(i)
            }
        }
        this.setState({kolumny: arr})
        LSService.ustawZestawKolumnWBiletachMiesiecznych(arr)

    }

    renderCena(cell, row) {
        return acc.formatMoney(cell)
    }

    renderStatusy(cell, row) {
        if (!Boolean(row.idBmGl)) {
            let status = this.state.statusy.find(s => s.value == cell)
            let formaplat = ''
            if (row.formaPlatn == 'GK') formaplat = 'gotówka'
            if (row.formaPlatn == 'KK') formaplat = 'karta'
            if (row.formaPlatn == 'PR') formaplat = 'przelew'
            return (<div>
                <MiesieczneTableStatus status={Boolean(status) ? status : null}
                                       statusy={this.state.statusy}
                                       handleChangeStatus={(status) => this.props.handleChangeStatus(row, status)}/>
                <div style={{marginTop: '1px', marginLeft: '10px', color: 'grey', fontStyle: 'italic'}}>{formaplat}</div>
            </div>)
        } else return ''
    }

    renderKod(cell, row) {
        return <span className={'label label-ebus-default'}>{cell}</span>
    }

    renderKlient = (cell, row) => {
        if (Boolean(row.idKl)) {
            return (
                <div>
                    <div data-tip='' data-for={'klient_data' + row.idKl + '-' + row.idBm} data-place="bottom" className='tooltip_here'>
                        <div style={{display: 'inline-block', lineHeight: '1.1em'}}>
                            <div>
                                <Link to={'/zarzadzanie-klientami/klient/' + row.idKl} target={'_blank'}>
                                    {Boolean(row.imieKl) ? <span>{row.imieKl + ' ' + row.nazKl}</span> : ''}
                                </Link>
                            </div>
                            <div style={{color: 'grey', fontSize: '12px', lineHeight: '1.1em', marginTop: '3px'}}>
                                {Boolean(row.peselKl) ? <span style={{display: 'inline-block', marginRight: '3px'}}><i
                                    className={'fa fa-id-card-o'}></i> {row.peselKl}</span> : ''}
                                {Boolean(row.emailKl) ?
                                    <span style={{display: 'inline-block', color: "dodgerblue", textDecoration: "underline", cursor: "pointer"}}
                                          onClick={() => this.setState({
                                              pokazPopupWyslijEmail: true, adresatEmail: row.emailKl
                                          })}><i className={'fa fa-envelope'}></i> {row.emailKl}</span> : ''}
                            </div>
                        </div>

                    </div>
                    <ReactTooltip id={'klient_data' + row.idKl + '-' + row.idBm}>
                        <Row>
                            <Col xs={12}>
                                <div>
                                    {
                                        Boolean(row.imieKl) ?
                                            <div style={{lineHeight: '2em'}}><i className='fa fa-user'
                                                                                style={{marginRight: '5px'}}></i> {row.imieKl + ' ' + row.nazKl}
                                            </div> : ''
                                    }{
                                    Boolean(row.peselKl) ?
                                        <div style={{lineHeight: '2em'}}><i className='fa fa-id-card-o'
                                                                            style={{marginRight: '5px'}}></i>Pesel: {row.peselKl}
                                        </div> : ''
                                }
                                    {
                                        Boolean(row.telefonKl) ?
                                            <div style={{lineHeight: '2em'}}><i className='fa fa-phone'
                                                                                style={{marginRight: '5px'}}></i>Telefon: {row.telefonKl}
                                            </div> : ''
                                    }
                                    {
                                        Boolean(row.emailKl) ?
                                            <div style={{lineHeight: '2em'}}><i className='fa fa-envelope'
                                                                                style={{marginRight: '5px'}}></i>Email: {row.emailKl}
                                            </div> : ''
                                    }
                                </div>
                            </Col>
                        </Row>

                    </ReactTooltip>
                </div>
            )
        }
    }

    renderKierunek(cell, row) {
        if (cell === 1) {
            // w jedna stronę
            return <div title={'Przejazd tylko w jednym kierunku'} style={{textAlign: 'center', lineHeight: '30px'}}>
                <i className={'fa fa-long-arrow-right'}></i>
            </div>
        }
        else if (cell === 2) {
            return <div title={'Przejazd w obydwa kierunki'} style={{textAlign: 'center', lineHeight: '30px'}}>
                <i className={'fa fa-exchange'}></i>
            </div>
        }
        else return cell
    }

    renderOkres(cell, row) {
        if (cell === 'P1') {
            return <div title={'Pierwsza połowa miesiąca'} style={{textAlign: 'center', lineHeight: '30px'}}>
                <i className={'fa fa-adjust'} style={{transform: 'rotate(180deg)'}}></i>
            </div>
        }
        else if (cell === 'P2') {
            return <div title={'Druga połowa miesiąca'} style={{textAlign: 'center', lineHeight: '30px'}}>
                <i className={'fa fa-adjust'}></i>
            </div>
        }
        else if (cell === 'M1') {
            return <div title={'Cały miesiąc'} style={{textAlign: 'center', lineHeight: '30px'}}>
                <i className={'fa fa-circle'}></i>
            </div>

        }
        else return cell
    }

    renderMiesiacRok(cell, row) {
        let msc = this.state.miesiace.find(m => m.value === row.miesiac)
        return (<div>
            <div>{row.rok + ', ' + msc.label}</div>
            <div style={{color: 'grey', fontSize: '12px', fontStyle: 'italic'}}>{row.waznyOd + ' - '}<br/>{row.waznyDo}</div>
        </div>)
    }

    formatOdcinek(cell, row) {
        return (
            <div>
                <div><span className={'label label-ebus-default'}>{row.nazTr}</span></div>
                <div style={{marginTop: '5px'}}>
                    <span>
                        <span>{row.nazMiOd}</span>
                        <i className={'fa fa-long-arrow-right'} style={{margin: '0 2px'}}></i>
                        <span>{row.nazMiDo}</span>
                    </span>
                </div>
            </div>
        )
    }

    renderKarta(cell, row) {
        return <span className={'label label-ebus-primary'}>{cell}</span>
    }

    renderPlatnosci(cell, row) {
        return (<div>
            <div>{Boolean(row.platnosciTransakcja) ? row.platnosciTransakcja : ''}</div>
            <div>{Boolean(row.platnoscTpay) ? row.platnoscTpay : ''}</div>
        </div>)
    }

    checkVisible(number) {
        return (this.state.kolumny.indexOf(number) !== -1)
    }

    pobierzFakture = (cell, row) => {
        if (!Boolean(row.idBmGl)) {
            return (<TopButtonPointAction onClick={() => this.onClickPobierzFakture(cell)}
                                          buttonColor={'default'}
                                          buttonIcon={'fa fa-download'}
                                          titleContent={'Pobierz fakturę'}

            />)
        }
    }

    wystawFakture(cell, row) {
        if (!Boolean(row.idBmGl)) {
            if (Boolean(row.nipParagon)) {
                return (<TopButtonPointAction onClick={() => this.onClickWystawFakture(row)} buttonIcon={'fa fa-file-text-o'} buttonColor={'default'}
                                              titleContent={'Wystaw fakturę na bilet'}/>)
            } else {
                return <span style={{color: 'red'}}>brak NIP!</span>
            }
        }

    }

    onClickPobierzFakture(idBm) {
        BiletyService.pobierzLubPokazFaktureZaBiletMiesieczny(idBm, true).then(function (response) {
            const content = response.headers['content-type'];
            download(response.data, 'Bilet-msc-' + idBm, content)
        }.bind(this)).catch(err => {
            alert('Błąd - nie można pobrać faktury')
            console.log(err)
        })
    }

    onClickWystawFakture(obj) {
        console.log(obj)
        this.setState({
            pokazModal: true,
            bilet: obj,
        })
    }

    expandComponent(row) {

        return <div style={{borderBottom: '3px solid #83c33a', paddingBottom: '5px'}}>
            <div className={'well well-sm'} style={{marginBottom: '5px'}}>
                {row.uwagi}
            </div>
        </div>

    }

    expandColumnComponent({isExpandableRow, isExpanded}) {
        let content = '';

        if (isExpandableRow) {
            content = (isExpanded ?
                    (<i style={{display: "block", textAlign: "center"}} className='fa fa-lg fa-caret-up'></i>)
                    :
                    (<i style={{display: "block", textAlign: "center"}} className='fa fa-lg fa-caret-down'></i>)
            )
        } else {
            content = ' ';
        }
        return (
            <div> {content} </div>
        );
    }

    isExpandableRow(row) {
        return (Boolean(row.uwagi))
    }

    render() {
        const options = {
            sizePerPage: 15,  // Showing 30 for the size per page as default
            sizePerPageList: [10, 15, 30],
            sortName: 'idBm',
            sortOrder: 'desc',
            noDataText: 'Brak pasujących rekordów',
            expandBy: 'column'
        };

        let okresy = {
            "P1": "I połowa",
            "P2": "II połowa",
            "M1": "cały miesiąc",
        }

        let kierunki = {
            1: "jednostronny",
            2: "dwustronny"
        }

        let statusy = {
            '-2': 'anulowany',
            '-1': 'do opłaty',
            '1': 'opłacony'
        }

        return (
            <div>
                <div>
                    <div>
                        <div className={'pull-right'} id={'visibilitycolumncheckboxes'}>
                            <ControlLabel style={{marginRight: '15px'}}>
                                Pokaż kolumny:
                            </ControlLabel>
                            <Checkbox inline={true} checked={this.state.kolumny.indexOf(0) !== -1} onClick={() => this.onClickChangeColumnVisible(0)}>
                                Kod
                            </Checkbox>
                            <Checkbox inline={true} checked={this.state.kolumny.indexOf(1) !== -1} onClick={() => this.onClickChangeColumnVisible(1)}>
                                Data
                            </Checkbox>
                            <Checkbox inline={true} checked={this.state.kolumny.indexOf(2) !== -1} onClick={() => this.onClickChangeColumnVisible(2)}>
                                Okres
                            </Checkbox>
                            <Checkbox inline={true} checked={this.state.kolumny.indexOf(3) !== -1} onClick={() => this.onClickChangeColumnVisible(3)}>
                                Karta
                            </Checkbox>
                            <Checkbox inline={true} checked={this.state.kolumny.indexOf(4) !== -1} onClick={() => this.onClickChangeColumnVisible(4)}>
                                Klient
                            </Checkbox>
                            <Checkbox inline={true} checked={this.state.kolumny.indexOf(5) !== -1} onClick={() => this.onClickChangeColumnVisible(5)}>
                                Odcinek
                            </Checkbox>
                            <Checkbox inline={true} checked={this.state.kolumny.indexOf(6) !== -1} onClick={() => this.onClickChangeColumnVisible(6)}>
                                Kierunek
                            </Checkbox>
                            <Checkbox inline={true} checked={this.state.kolumny.indexOf(7) !== -1} onClick={() => this.onClickChangeColumnVisible(7)}>
                                e-płatność
                            </Checkbox>
                            <Checkbox inline={true} checked={this.state.kolumny.indexOf(8) !== -1} onClick={() => this.onClickChangeColumnVisible(8)}>
                                Cena
                            </Checkbox>
                            <Checkbox inline={true} checked={this.state.kolumny.indexOf(9) !== -1} onClick={() => this.onClickChangeColumnVisible(9)}>
                                Rodzaj
                            </Checkbox>
                            <Checkbox inline={true} checked={this.state.kolumny.indexOf(10) !== -1}
                                      onClick={() => this.onClickChangeColumnVisible(10)}>
                                Status
                            </Checkbox>
                            <Checkbox inline={true} checked={this.state.kolumny.indexOf(11) !== -1}
                                      onClick={() => this.onClickChangeColumnVisible(11)}>
                                Sprzedaż miejsce
                            </Checkbox>
                            <Checkbox inline={true} checked={this.state.kolumny.indexOf(12) !== -1}
                                      onClick={() => this.onClickChangeColumnVisible(12)}>
                                Opis
                            </Checkbox>
                        </div>
                    </div>
                    <div>
                        <div>
                            <BootstrapTable data={this.props.data}
                                            options={options}
                                            pagination
                                            hover
                            >
                                <TableHeaderColumn dataField='idBm' isKey expandable={false}
                                                   filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                                   dataFormat={this.renderKod} dataSort
                                                   hidden={!this.checkVisible(0)}
                                                   thStyle={(this.checkVisible(0)) ? tabgrid.tg1 : {}}
                                                   tdStyle={(this.checkVisible(0)) ? tabgrid.tg1 : {}}
                                >Kod</TableHeaderColumn>
                                <TableHeaderColumn dataField='miesiac'
                                                   filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}} expandable={false}
                                                   dataFormat={this.renderMiesiacRok}
                                                   hidden={!this.checkVisible(1)}
                                                   thStyle={(this.checkVisible(1)) ? tabgrid.tg2 : {}}
                                                   tdStyle={(this.checkVisible(1)) ? tabgrid.tg2 : {}}
                                >Data</TableHeaderColumn>
                                <TableHeaderColumn dataField='okres'
                                                   filter={{type: 'SelectFilter', options: okresy, selectText: ''}} formatExtraData={okresy}
                                                   expandable={false}
                                                   dataFormat={this.renderOkres}
                                                   hidden={!this.checkVisible(2)}
                                                   thStyle={(this.checkVisible(2)) ? tabgrid.tg1 : {}}
                                                   tdStyle={(this.checkVisible(2)) ? tabgrid.tg1 : {}}
                                >Okres</TableHeaderColumn>
                                <TableHeaderColumn dataField='nrKarty' expandable={false}
                                                   filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                                   dataFormat={this.renderKarta}
                                                   hidden={!this.checkVisible(3)}
                                                   thStyle={(this.checkVisible(3)) ? tabgrid.tg2 : {}}
                                                   tdStyle={(this.checkVisible(3)) ? tabgrid.tg2 : {}}
                                >Nr karty</TableHeaderColumn>
                                <TableHeaderColumn dataField='infoKlient'
                                                   expandable={false}
                                                   filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                                   dataFormat={this.renderKlient}
                                                   hidden={!this.checkVisible(4)}
                                                   thStyle={(this.checkVisible(4)) ? tabgrid.tg4 : {}}
                                                   tdStyle={(this.checkVisible(4)) ? tabgrid.tg4 : {}}
                                ><InfoTooltip label={'Klient'} text={'Można szukać po: imie, nazwisko, pesel, telefon, email'}/></TableHeaderColumn>
                                <TableHeaderColumn dataField='infoOdcinek'
                                                   filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}} expandable={false}
                                                   dataFormat={this.formatOdcinek}
                                                   hidden={!this.checkVisible(5)}
                                                   thStyle={(this.checkVisible(5)) ? tabgrid.tg3 : {}}
                                                   tdStyle={(this.checkVisible(5)) ? tabgrid.tg3 : {}}
                                ><InfoTooltip label={'Odcinek'}
                                              text={'Można szukać po: nazwa trasy, nazwa miejscowości od, nazwa miejscowości do'}/></TableHeaderColumn>
                                <TableHeaderColumn dataField='kierunek'
                                                   expandable={false}
                                                   filter={{type: 'SelectFilter', options: kierunki, selectText: ''}} formatExtraData={kierunki}
                                                   dataFormat={this.renderKierunek}
                                                   hidden={!this.checkVisible(6)}
                                                   thStyle={(this.checkVisible(6)) ? tabgrid.tg1 : {}}
                                                   tdStyle={(this.checkVisible(6)) ? tabgrid.tg1 : {}}
                                >Kier</TableHeaderColumn>
                                <TableHeaderColumn dataField='infoPlatnosci' dataSort expandable={false}
                                                   filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                                   dataFormat={this.renderPlatnosci}
                                                   hidden={!this.checkVisible(7)}
                                                   thStyle={(this.checkVisible(7)) ? tabgrid.tg2 : {}}
                                                   tdStyle={(this.checkVisible(7)) ? tabgrid.tg2 : {}}
                                >e-płatność</TableHeaderColumn>
                                <TableHeaderColumn dataField='cena' dataSort
                                                   filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                                   dataFormat={this.renderCena}
                                                   hidden={!this.checkVisible(8)}
                                                   thStyle={(this.checkVisible(8)) ? tabgrid.tg2 : {}}
                                                   tdStyle={(this.checkVisible(8)) ? tabgrid.tg2 : {}}
                                >Cena</TableHeaderColumn>
                                <TableHeaderColumn dataField='rodz'
                                                   expandable={false}
                                                   filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                                   dataFormat={(cell, row) => {
                                                       return <span title={row.nazZniz} style={{color: '#fff', background: row.kolor}}
                                                                    className={'label label-ebus-default'}>{cell}</span>
                                                   }}
                                                   hidden={!this.checkVisible(9)}
                                                   thStyle={(this.checkVisible(9)) ? tabgrid.tg1 : {}}
                                                   tdStyle={(this.checkVisible(9)) ? tabgrid.tg1 : {}}
                                >Rodz</TableHeaderColumn>
                                <TableHeaderColumn dataField='status' dataSort
                                                   expandable={false}
                                                   filter={{type: 'SelectFilter', options: statusy, selectText: '', condition: 'like'}}
                                                   formatExtraData={statusy}
                                                   dataFormat={this.renderStatusy}
                                                   hidden={!this.checkVisible(10)}
                                                   thStyle={(this.checkVisible(10)) ? tabgrid.tg3 : {}}
                                                   tdStyle={(this.checkVisible(10)) ? tabgrid.tg3 : {}}
                                >Status</TableHeaderColumn>
                                <TableHeaderColumn dataField={'sprzedazMiejsce'}
                                                   dataSort
                                                   expandable={false}
                                                   filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                                   hidden={!this.checkVisible(11)}
                                                   thStyle={(this.checkVisible(11)) ? tabgrid.tg1 : {}}
                                                   tdStyle={(this.checkVisible(11)) ? tabgrid.tg1 : {}}
                                                   dataFormat={(cell, row) => <span style={{fontSize: "12px"}}>{cell}</span>}
                                >Sprzedaż</TableHeaderColumn>
                                <TableHeaderColumn dataField='uwagi'
                                                   expandable={false}
                                                   filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                                   dataFormat={(cell, row) => {
                                                       if (Boolean(row.uwagi))
                                                           return (<i className={'fa fa-info-circle'}
                                                                      title={row.uwagi}
                                                                      style={{cursor: 'pointer'}}
                                                                      onClick={() => alert(row.uwagi)}></i>
                                                           )
                                                   }}
                                                   hidden={!this.checkVisible(12)}
                                                   thStyle={(this.checkVisible(12)) ? tabgrid.tg1 : {}}
                                                   tdStyle={(this.checkVisible(12)) ? tabgrid.tg1 : {}}
                                >Opis</TableHeaderColumn>
                                <TableHeaderColumn
                                    dataField='idBm'
                                    expandable={false}
                                    dataFormat={(cell, row) => this.pobierzFakture(cell, row)}
                                    thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                >
                                    Pobierz fakture
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    dataField='idBm'
                                    expandable={false}
                                    dataFormat={(cell, row) => this.wystawFakture(cell, row)}
                                    thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                >
                                    <div style={{fontSize: '12px', textAlign: 'center'}}>Wystaw fakturę VAT</div>
                                </TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                    {
                        this.state.pokazModal ?
                            <WystawFaktureZaBiletMiesieczny bilet={this.state.bilet} handleClickZamknij={() => {
                                this.setState({
                                    pokazModal: false,
                                    bilet: null,
                                })
                            }}/>
                            :
                            ''
                    }
                </div>
                {
                    (this.state.pokazPopupWyslijEmail) ?
                        <WyslijMailDoKlientaPopup adresat={this.state.adresatEmail}
                                                  onClickZamknij={() => this.setState({pokazPopupWyslijEmail: false, adresatEmail: ""})}/>
                        : ""
                }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/biletyMiesieczne/components/MiesieczneTable.js